<template>
  <div class="cont-box" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <img class="title-header" src="../../assets/global-bg.png" />
    <div>
      <div class="list">
        <div class="title-cont">
          <img class="title-img" src="../../assets/b-title-des.png" />
          <p class="title">年度整体经营目标</p>
          <img class="title-img resever" src="../../assets/b-title-des.png" />
        </div>
        <Echart07M id="global" :datas="data02" :items="items" :dimensions="dimensions" height="360px" />
      </div>
    </div>
    <NavStyle :navIndex="2"></NavStyle>
  </div>
</template>

<script>
  import Echart07M from '../../components/Echart07M.vue'
  import NavStyle from '../../components/NavStyle.vue'
  
  export default {
    name: 'Global',
    components: {
      Echart07M,
      NavStyle
    },
    data() {
      return {
        loading: false,
        items: [],
        dimensions: ['name', 'firstYear', 'secondYear', 'thirdYear'],
        data02: []
        // data02: [
        //   {type: "销售目标", value1: 137500, value2: 272500, value3: 204000}, 
        //   {type: "合同额", value1: 103049, value2: 161382, value3: 204000},
        //   {type: "营业收入", value1: 89196, value2: 114081, value3: 135000},
        //   {type: "费用", value1: 2322, value2: 3257, value3: 2550},
        //   {type: "销售回款额", value1: 96345, value2: 132011, value3: 125000},
        //   {type: "年度净利润", value1: 3051, value2: 461, value3: 5000}
        // ]
      }
    },
    mounted() {
      this.$axios.post('/annual_general/findList').then( res => {
        this.data02 = res.data.data.slice(0, 5)
        let obj = res.data.data[5]
        this.items = [obj.firstYear, obj.secondYear, obj.thirdYear,]
      })
    },
    methods: {

    }
  }
</script>

<style scoped>
  .cont-box {
    background-color: #08103c;
    min-height: 100%;
  }

  .title-header {
    width: 100%;
  }

  .resever {
    transform: scaleX(-1);
  }

  .title-cont {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .title-img {
    width: 80px;
  }

  .title {
    color: #2dfcff;
    font-size: 16px;
    font-weight: bold;
    padding: 0 10px;
    white-space: nowrap;
  }

  .list {
    padding-bottom: 40px;
  }
  
  .icon-list {
    padding: 0 0 10px;
    display: flex;
    justify-content: center;
    margin: -10px 0 40px;
  }
  .icon {
    width: 40%;
    background: rgba(0, 0, 0, .2);
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgba(45, 252, 255, .2);
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0;
    color: rgba(255, 255, 255, .6);
  }
  
  .icon-cur{
    color: white;
    background-color: #1fd6d9;
  }
  
  .title-cont01 {
    margin-bottom: 20px
  }
  .echart-box {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
  }
  .echart-box > div {
    width: 50%;
  }
  .time {
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, .6);
    font-size: 12px;
    padding: 6px;
  }
</style>
